import React from 'react';
import {css, view} from '@sail/ui/deprecated';

import {AvatarSpacer} from '@stripe-internal/conversations-ui';

import {SupportAIAvatar} from './SupportAIAvatar';
import {SupportAIHeader} from './SupportAIHeader';

// With the Support AI Brand, the children (aka message bubble)
// is rendered underneath the avatar and header.
export const SupportAIBrandResponse = ({
  isLoading,
  children,
}: {
  isLoading: boolean;
  children: React.ReactNode;
}) => {
  return (
    <view.div
      data-testid="live-answers-support-ai-brand"
      css={{
        stack: 'y',
        gap: 'xsmall',
        marginRight:
          // Remove right side padding to avoid text wrap while showing loading message
          isLoading ? undefined : 'large',
      }}
    >
      <view.div
        css={{
          stack: 'x',
          gap: 'small',
          alignItems: css.value('center'),
        }}
      >
        <SupportAIAvatar />
        <SupportAIHeader />
      </view.div>
      <view.div
        css={{
          stack: 'x',
          gap: 'small',
        }}
      >
        <AvatarSpacer />
        <view.div
          data-testid="live-answers-response-content-wrapper"
          css={{
            // Allow child response bubbles grow to fill all available space.
            width: 'fill',
            // In order to support ellipsis text overflow in the sources list we need to
            // set a fixed width here, so we take the parent width minus the width of the
            // other components in the stack (avatar width + column gap).
            maxWidth: css.value('calc(100% - (28px + var(--column-gap)))'),
          }}
        >
          {children}
        </view.div>
      </view.div>
    </view.div>
  );
};
